import React, { useEffect, useRef, useState } from "react";
import Block from "../Blocks/block";
import ContentWrapper from "../Blocks/contentWrapper";
import SectionWrapper from "../Blocks/sectionWrapper";
import BlockContent from "../Blocks/blockContent";
import Title from "../Blocks/title";
import Divider from "../Blocks/divider";
import Paragraph from "../Blocks/paragraph";
import PageWrapper from "../Blocks/pageWrapper";
import Stepper from "../Blocks/stepper";
import { EColor, EIconGlyph, ESize, MFontSizeProperties } from "../../styleConstants";
import Button from "../Blocks/button";
import copy from 'copy-to-clipboard';
import Translate from "../Translate";
import DisabledContent from "../Blocks/disabledContent";
import { shareWithAPI } from "./apiShare";
import FriendReferralHero from "./referalHero";
import { useIsMobile } from "../styleUtils";

export default function FriendReferral ({
    referralLink,
    referralId,
    tag
}: {
    referralLink: string
    referralId: string
    tag: string
}) {
    const [shareAPIavailable, setShareAPIavailable] = useState<boolean>(false);
    const isMobile = useIsMobile()
    const stepperStart = useRef<HTMLDivElement>()
    const [linkCopied, setLinkCopied] = useState<boolean>(false)

    useEffect(() => {
        setShareAPIavailable(navigator["share"] ? true : false)
    }, [])
    
    return (
        <PageWrapper>
            <FriendReferralHero referralId={referralId} referralLink={referralLink} tag={tag} stepperStart={stepperStart} />

            <DisabledContent disableWhen="desktop">
                <SectionWrapper> 
                    <Divider />
                </SectionWrapper>
            </DisabledContent>
            
            <SectionWrapper>
                <ContentWrapper>
                    
                    <Block>
                        <BlockContent bleed="right">
                            <div ref={stepperStart}>
                                <Title size={8} margin={ESize.default}>
                                    <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.title`} />
                                </Title>
                            </div>
                            <Stepper>
                                <div>
                                    <Title size={6} weight={500} margin={ESize.small}>
                                        <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.step_1.title`} />
                                    </Title>

                                    {isMobile ? 
                                        <div onClick={() => { shareWithAPI(referralLink) }}>
                                            <Button 
                                                type="tertiary" 
                                                icon={EIconGlyph.share_android} 
                                                label={Translate.path("views.site_pages.refer_a_friend_v2.share")} 
                                                colorOverrided={EColor.SunglowYellow}
                                            />
                                        </div>    
                                        :
                                        <div onClick={() => { 
                                            copy(referralLink); 
                                            setLinkCopied(true)
                                        }}>
                                            <Button 
                                                type="tertiary" 
                                                icon={EIconGlyph.share_android} 
                                                label={
                                                    linkCopied
                                                        ? Translate.path("views.site_pages.refer_a_friend_v2.copied")
                                                        : Translate.path("views.site_pages.refer_a_friend_v2.copy")
                                                } 
                                                colorOverrided={EColor.SunglowYellow}
                                            />
                                        </div>
                                    }
                                </div>
                                
                                <div>
                                    <Title size={6} weight={500} margin={ESize.small}>
                                        <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.step_2.title`} />
                                    </Title>
                                    <Paragraph size={3} weight={400}>
                                        <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.step_2.body`} />
                                    </Paragraph>
                                </div>
                                <div>
                                <Title size={6} weight={500} margin={ESize.small}>
                                        <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.step_3.title`} />
                                    </Title>
                                    <Paragraph size={3} weight={400}>
                                        <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.step_3.body`} />
                                    </Paragraph>
                                </div>
                                <div>
                                <Title size={6} weight={500} margin={ESize.small}>
                                        <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.step_4.title`} />
                                    </Title>
                                    <Paragraph size={3} weight={400}>
                                        <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.step_4.body`} />
                                    </Paragraph>
                                </div>
                            </Stepper>
                            <Paragraph size={2} margin={ESize.small} color={EColor.MountainGray}>
                                <Translate path={`views.site_pages.refer_a_friend_campaign.${tag}.share.stepper.disclaimer`} />
                            </Paragraph>
                        </BlockContent>
                    </Block>
                </ContentWrapper>
            </SectionWrapper>
            {
                /*
                <SectionWrapper> 
                    <Divider />
                </SectionWrapper>

                <SectionWrapper>
                    <ContentWrapper >
                        <Block>
                            <BlockContent bleed="none" fullWidth={true}>
                                <Title size={8} margin={ESize.default}>
                                    <Translate path={`views.site_pages.refer_a_friend_v2.invited_friends`} />
                                </Title>
                                <ReferredFriends/>
                            </BlockContent>
                        </Block>
                    </ContentWrapper>
                </SectionWrapper>
                */
            }
        </PageWrapper>
    )
}